const staticfilesversion : string = ((window as any).staticfilesversion
? (window as any).staticfilesversion
: "").toLowerCase();
export const CACHE_KEY = 'translations'+staticfilesversion;
export const CACHE_EXPIRATION = 12 * 60 * 60 * 1000;

interface CacheData {
  timestamp: number;
  translations: Record<string, string>;
}

export const saveToCache = (lng: string, translations: Record<string, string>): void => {
  const cacheData: CacheData = {
    timestamp: Date.now(),
    translations,
  };
  localStorage.setItem(`${CACHE_KEY}_${lng}`, JSON.stringify(cacheData));
};


export const loadFromCache = (lng: string): Record<string, string> | null => {
  const cacheData = localStorage.getItem(`${CACHE_KEY}_${lng}`);
  if (!cacheData) return null;

  try {
    const parsedData: CacheData = JSON.parse(cacheData);
    if (Date.now() - parsedData.timestamp > CACHE_EXPIRATION) {
      localStorage.removeItem(`${CACHE_KEY}_${lng}`);
      return null;
    }
    return parsedData.translations;
  } catch (error) {
    console.error('Error parsing cached translations:', error);
    return null;
  }
};

